/* Core */
import eventsCustom from './events.js';
import lazyFancybox from './lazy-fancybox.js';
import lazyTriggers from './lazy-triggers.js';
import { loadChunk } from './chunks.js';
import { SCROLL_EFFECTS_SELECTOR } from '../ui/scroll-effects.js';

/* Utils */
import motionControl from '../ui/motion-control.js';
import platformDetect from '../utils/platform-detect.js';
import anchorScroll from '../ui/anchor-scroll.js';
import pointerDetect from '../utils/pointer-detect.js';
import scrollDirection from '../ui/scroll-direction.js';
import cookieConsent from '../utils/cookie-consent.js';

/* Components */
import skipLinks from '../components/skip-links.js';

export default {
    // JavaScript to be fired on all pages
    init() {
        /* Core */
        eventsCustom.init();
        lazyTriggers.init();
        lazyFancybox.init();

        /* Utils */
        motionControl.init();
        platformDetect.init();
        pointerDetect.init();
        anchorScroll.init();
        scrollDirection.init();
		cookieConsent.init();

        /* Components */
        skipLinks.init();

        /* Scroll effects : sans attendre le load (images, médias), les blocs animés étant masqués en CSS dès le départ.
           ScrollTrigger recalcule ses positions de lui-même au load. */
        this.initScrollEffects();
    },

    initScrollEffects() {
        if (document.querySelector(SCROLL_EFFECTS_SELECTOR)) {
            loadChunk('scrollEffects');
        }
    },
};
